const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') ??  '') : "";
const hasUser = user !== "";

const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') ?? '') : null;

export const  initalState = {
    emp: {
        first_name: userData ? userData.first_name : (hasUser ? user.user.first_name : ""),
        id_user: userData ? userData.id_user : (hasUser ? user.user.id_user : ""),
        last_name: userData ? userData.last_name : (hasUser ? user.user.last_name : ""),
        profile: userData ? userData.profile : (hasUser ? user.user.profile : ""),
        token: userData ? userData.token : (hasUser ? user.token : ""),
        idbusiness_group: userData ? userData.idbusiness_group : (hasUser ? user.user.idbusiness_group : null),
        id_client: userData ? userData.id_client : (hasUser ? user.user.id_client : null),
        client_name: userData ? userData.client_name : (hasUser ? user.user.client_name : null),
        },
        company: ""
};

const Reducer = (state = initalState, action: any) => {
    switch(action.type){
        case "SetEntornoEmp" : {
            return {...state, emp: action.emp};
        }
        case "USER_LOGOUT" : {
            return {...state};
        }
        case "GetEntornoEmp" : {
            return {...state};
        }                      
        case "GET_COMPANY_LOGO" : {
            return {...state, company: action.company };
        }                      
        default: return state;
    }
}

export default Reducer;